import React from "react";
import Cropper from "react-easy-crop";
import type { AvatarCropper } from "../hooks/useAvatarCropper";
import { t } from "../i18n";

// The round avatar cropper (pinch / drag / zoom slider, Cancel, Use this photo).
// Split out of pages/ProfilePage.tsx; the state lives in hooks/useAvatarCropper.

export default function AvatarCropModal({ cropper }: { cropper: AvatarCropper }) {
  const { cropSrc, cropPosition, setCropPosition, cropZoom, setCropZoom, cropAreaPixels, cropUploading, onCropComplete, cancelCrop, confirmCrop } = cropper;
  if (!cropSrc) return null;
  return (
    <div className="crop-modal">
      <div className="crop-modal-cropper">
        <Cropper
          image={cropSrc}
          crop={cropPosition}
          zoom={cropZoom}
          aspect={1}
          cropShape="round"
          showGrid={false}
          onCropChange={setCropPosition}
          onZoomChange={setCropZoom}
          onCropComplete={onCropComplete}
        />
      </div>
      <div className="crop-modal-controls">
        <p className="crop-modal-hint">{t("avatarCropModal.pinchToZoomDrag")}</p>
        <input
          type="range"
          className="crop-zoom-slider"
          min={1}
          max={3}
          step={0.05}
          value={cropZoom}
          onChange={(e) => setCropZoom(Number(e.target.value))}
          aria-label={t("avatarCropModal.zoom")}
          disabled={cropUploading}
        />
        <div className="crop-modal-buttons">
          <button
            type="button"
            className="crop-cancel-btn"
            onClick={cancelCrop}
            disabled={cropUploading}
          >
            {t("avatarCropModal.cancel")}
          </button>
          <button
            type="button"
            className="crop-confirm-btn"
            onClick={confirmCrop}
            disabled={cropUploading || !cropAreaPixels}
          >
            {cropUploading ? t("avatarCropModal.uploading") : t("avatarCropModal.useThisPhoto")}
          </button>
        </div>
      </div>
    </div>
  );
}
